module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/point_maedori_02-3c83f3af5cebff907de2629525679da9.webp";